import React, { useState, useEffect } from "react"
import {
  NeighbourhoodsContainer,
  OverlappedCarousel,
  SlideImg,
  DescriptionText,
  CarouselTextContainer,
} from "./style"
import { FlexGrid, FlexRow, FlexCol } from "components/FlexGrid"

import { SubtitleWrapper } from "components/ProjectStyles"
import Map from "./Map"
import { useStaticQuery, graphql } from "gatsby"

const Neighbourhoods = () => {
  const data = useStaticQuery(
    graphql`
      query {
        allFile(
          filter: { absolutePath: { regex: "/neighbourhoods-images/" } }
          sort: { fields: [name], order: ASC }
        ) {
          nodes {
            id
            name
            childImageSharp {
              fluid(maxWidth: 700, quality: 100) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    `
  )

  const images = data.allFile.nodes

  const neighbourhoodsData = [
    {
      title: "Tuggeranong Valley",
      excerpt:
        "Tuggeranong is bursting with Urban Development, especially real estate; multi-unit apartment buildings, redevelopment, retail centres, and comprehensive transport system, extensive residential development has sprung up all across the town.",
      img: images[0],
    },
    {
      title: "Weston Creek",
      excerpt:
        "Quisque id odio. Pellentesque ut neque. Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus. Suspendisse eu ligula.",
      img: images[1],
    },
    {
      title: "Woden",
      excerpt: `
    Sed mollis, eros et ultrices tempus, mauris ipsum aliquam libero, non adipiscing dolor urna a orci. Donec venenatis vulputate lorem. Sed magna purus, fermentum eu, tincidunt eu, varius ut, felis. Vestibulum ante ipsum primis`,
      img: images[2],
    },
    {
      title: "South Canberra",
      excerpt:
        "Phasellus consectetuer vestibulum elit. Vestibulum eu odio. Donec orci lectus, aliquam ut, faucibus non, euismod id, nulla. Nullam cursus lacinia erat.",
      img: images[3],
    },
    {
      title: "North Canberra",
      excerpt:
        "in faucibus orci luctus et ultrices posuere cubilia Curae; In ac dui quis mi consectetuer lacinia.in faucibus orci luctus et ultrices posuere cubilia Curae; In ac dui quis mi consectetuer lacinia.",
      img: images[4],
    },
    {
      title: "Belconnen",
      excerpt:
        "Fusce neque. Suspendisse nisl elit, rhoncus eget, elementum ac, condimentum eget, diam. Suspendisse enim turpis, dictum sed, iaculis a, condimentum nec, nisi.",
      img: images[5],
    },
    {
      title: "Gungahlin",
      excerpt:
        "Morbi vestibulum volutpat enim. Mauris turpis nunc, blandit et, volutpat molestie, porta ut, ligula. Etiam sit amet orci eget eros faucibus tincidunt. Fusce vulputate eleifend sapien.",
      img: images[6],
    },
  ]

  const [slideContent, setSlideContent] = useState(neighbourhoodsData[0])
  const [slideIndex, setSlideIndex] = useState(0)

  const handleSlideSelection = index => {
    setSlideIndex(index)
    setSlideContent(neighbourhoodsData[index])
  }

  return (
    <NeighbourhoodsContainer>
      <SubtitleWrapper>
        <h5>Discover</h5>
        <h2>Neighbourhoods</h2>
      </SubtitleWrapper>
      <FlexGrid fullWidth gap={[0, 30, 45]}>
        <FlexRow>
          <FlexCol xs={12} sm={8}>
            <CarouselTextContainer>
              <OverlappedCarousel
                fade
                loop
                draggable
                dotColor="#FFF"
                dragFree={false}
                onChange={handleSlideSelection}
                passedIndex={slideIndex}
              >
                {neighbourhoodsData.map((neighbourhood, index) => {
                  return (
                    <SlideImg
                      key={index}
                      fluid={neighbourhood.img.childImageSharp.fluid}
                    />
                  )
                })}
              </OverlappedCarousel>
              <DescriptionText>
                <h3>{slideContent.title}</h3>
                <p>{slideContent.excerpt}</p>
              </DescriptionText>
            </CarouselTextContainer>
          </FlexCol>
          <FlexCol xs={12} sm={4}>
            <Map
              slideIndex={slideIndex}
              handleSlideSelection={handleSlideSelection}
            />
          </FlexCol>
        </FlexRow>
      </FlexGrid>
    </NeighbourhoodsContainer>
  )
}

export default Neighbourhoods
